import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type WorkspaceAgentActionsMenuOpenedLocation } from './useTrackAgentActionsMenuOpened.meta';
import META from './useTrackAgentActionsMenuSkillsOpened.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type UseTrackAgentActionsMenuSkillsOpenedParams = {
  location: WorkspaceAgentActionsMenuOpenedLocation;
};

export const useTrackAgentActionsMenuSkillsOpened = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentActionsMenuSkillsOpened = useCallback(
    (params: UseTrackAgentActionsMenuSkillsOpenedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentActionsMenuSkillsOpened };
};
